import { useState, useContext } from "react";
import { TripFiltersContext } from "../../context/trip-filters.context";
import { Box, Button, Typography, useTheme } from "@mui/material";
import SelectField from "../select-field/select-field.component";
import DateField from "../date-field/date-field.component";
import LocalIcon from "../../assets/icons/localizacao.svg";
import { ReactComponent as CalendarInIcon } from "../../assets/icons/calendar entrada.svg";
import { ReactComponent as CalendarOutIcon } from "../../assets/icons/calendar saida.svg";

const countries = [
  "África",
  "América do Norte",
  "América Central",
  "América do Sul",
  "Ásia",
  "Europa",
  "Oceania",
];

const BasicTripSearcher = () => {
  const {
    destination,
    setDestination,
    boardingDate,
    setBoardingDate,
    arrivalDate,
    setArrivalDate,
    youngPassengers,
    oldPassengers,
  } = useContext(TripFiltersContext);
  const [formFields, setFormFields] = useState({
    destination,
    boardingDate,
    arrivalDate,
  });
  const tripDuration = arrivalDate
    ? arrivalDate.diff(boardingDate, "days") + 1
    : 0;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormFields({ ...formFields, [name]: value });
    setDestination(formFields.destination);
    setBoardingDate(formFields.boardingDate);
    setArrivalDate(formFields.arrivalDate);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setDestination(formFields.destination);
    setBoardingDate(formFields.boardingDate);
    setArrivalDate(formFields.arrivalDate);
  };

  const theme = useTheme();
  const passengers = youngPassengers + oldPassengers;

  const searchIcon = (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 21L16.7 16.7"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  // Painel único com os dados da viagem (mesmo layout no celular e no computador,
  // só muda a grade).
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.grey[50],
        borderRadius: 3,
        p: { xs: 2, md: 2.5 },
      }}
    >
      <Typography sx={{ fontSize: "0.9rem", mb: 1.5 }}>
        <b>Sua viagem</b>
        {tripDuration > 0 && (
          <Box component="span" sx={{ color: "text.secondary" }}>
            {" "}
            · {tripDuration} {tripDuration === 1 ? "dia" : "dias"}
            {passengers > 0 &&
              ` · ${passengers} ${passengers === 1 ? "pessoa" : "pessoas"}`}
          </Box>
        )}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", md: "1.3fr 1fr 1fr auto" },
            gap: { xs: 1.5, md: 2 },
            alignItems: "stretch",
            "& > *": { minWidth: 0 },
          }}
        >
          <Box sx={{ gridColumn: { xs: "1 / -1", md: "auto" } }}>
            <SelectField
              label="Destino"
              type="text"
              name="destination"
              variant="white"
              icon={LocalIcon}
              required
              onChange={handleChange}
              value={destination}
              options={countries}
              floatingLabel={false}
            />
          </Box>
          <DateField
            label="Partida"
            type="text"
            name="boardingDate"
            variant="white"
            icon={CalendarInIcon}
            required
            onChange={handleChange}
            value={boardingDate}
          />
          <DateField
            label="Retorno"
            type="text"
            name="arrivalDate"
            variant="white"
            icon={CalendarOutIcon}
            required
            onChange={handleChange}
            value={arrivalDate}
            minDate={boardingDate}
          />
          <Button
            type="submit"
            variant="contained"
            endIcon={searchIcon}
            sx={{
              gridColumn: { xs: "1 / -1", md: "auto" },
              backgroundColor: "primary.dark",
              "&:hover": { backgroundColor: "primary.main" },
              borderRadius: "8px",
              px: 3,
              py: 1.25,
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            Pesquisar
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default BasicTripSearcher;
